import { render, staticRenderFns } from "./cialdetyxtj.vue?vue&type=template&id=450dfd5e&scoped=true&"
import script from "./cialdetyxtj.vue?vue&type=script&lang=js&"
export * from "./cialdetyxtj.vue?vue&type=script&lang=js&"
import style0 from "./cialdetyxtj.vue?vue&type=style&index=0&id=450dfd5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450dfd5e",
  null
  
)

export default component.exports